(() => {
  'use strict';
  const notices = document.querySelectorAll('[data-asos-promo-end]');
  if (!notices.length) return;
  let timer;
  const check = () => {
    clearTimeout(timer);
    let next = Infinity;
    notices.forEach((notice) => {
      const end = Date.parse(notice.dataset.asosPromoEnd);
      const remaining = end - Date.now();
      if (!Number.isFinite(end) || remaining <= 0) {
        notice.hidden = true;
      } else {
        next = Math.min(next, remaining);
      }
    });
    if (Number.isFinite(next)) timer = setTimeout(check, Math.min(next, 2147483647));
  };
  check();
  document.addEventListener('visibilitychange', check);
  window.addEventListener('pageshow', check);
})();
